module.exports = __webpack_public_path__ + "media/Audio16_h.a052ff79.wav";